<template>
  <div class="inspectionReport">
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="质量检验详情"
        class="customer-edit"
        width="1200px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          style="position: relative"
          :model="inspectionReport"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <el-button
            style="position: absolute;top: 0;right: 10px;z-index: 100"
            :loading="exportLoading"
            type="primary"
            @click="previewExportExcel()">
          导出
        </el-button>
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane label="基本信息" name="first">
            <div>
              <table class="table" cellpadding="0" cellspacing="0" :data="controlBoxFlow">
                <tr>
                  <td class="tableLabel">载重：</td>
                  <td class="tableModel">{{controlBoxFlow.load}}</td>
                  <td class="tableLabel">梯速：</td>
                  <td class="tableModel">{{controlBoxFlow.speed}}</td>
                  <td class="tableLabel">说明书：</td>
                  <td class="tableModel">{{controlBoxFlow.instruction}}</td>
                </tr>
                <tr>
                  <td class="tableLabel">出厂编号：</td>
                  <td class="tableModel">{{controlBoxFlow.techParamBillNo}}</td>
                  <td class="tableLabel">合同编号：</td>
                  <td class="tableModel">{{controlBoxFlow.clientContractNo}}</td>
                  <td class="tableLabel">主板类型：</td>
                  <td class="tableModel">{{controlBoxFlow.mainBoardType}}</td>
                </tr>
                <tr>
                  <td class="tableLabel">项目名称：</td>
                  <td class="tableModel">{{controlBoxFlow.projectName}}</td>
                  <td class="tableLabel">项目类型：</td>
                  <td class="tableModel">{{controlBoxFlow.projectType}}</td>
                  <td class="tableLabel">随机文件：</td>
                  <td class="tableModel">{{controlBoxFlow.doc}}</td>
                </tr>
                <tr>
                  <td class="tableLabel">柜体型号：</td>
                  <td class="tableModel">{{controlBoxFlow.controlCabinet}}</td>
                  <td class="tableLabel">柜体颜色：</td>
                  <td class="tableModel">{{controlBoxFlow.controlCabinetColor}}</td>
                  <td class="tableLabel">开门方向：</td>
                  <td class="tableModel">{{controlBoxFlow.doorOpeningDirection}}</td>
                </tr>
                <tr>
                  <td class="tableLabel">控制方式：</td>
                  <td class="tableModel">{{controlBoxFlow.controlType}}</td>
                  <td class="tableLabel">层#站#门：</td>
                  <td class="tableModel">{{controlBoxFlow.floor}}</td>
                  <td class="tableLabel">控制柜名牌：</td>
                  <td class="tableModel">{{controlBoxFlow.controlCabinetNameplate}}</td>
                </tr>
                <tr>
                  <td class="tableLabel">销售订单号：</td>
                  <td class="tableModel">{{controlBoxFlow.sapOID}}</td>
                  <td class="tableLabel">主板软件号：</td>
                  <td class="tableModel">{{controlBoxFlow.softwareVersion}}</td>
                  <td class="tableLabel">变频器功率：</td>
                  <td class="tableModel">{{controlBoxFlow.inverterPower}}</td>
                </tr>
                <tr>
                  <td class="tableLabel">电动机功率：</td>
                  <td class="tableModel">{{controlBoxFlow.motorPower}}</td>
                  <td class="tableLabel">电动机电压等级：</td>
                  <td class="tableModel">{{controlBoxFlow.motorVoltageLevel}}</td>
                  <td class="tableLabel">是否外带电阻箱：</td>
                  <td class="tableModel">{{controlBoxFlow.resistanceBox}}</td>
                </tr>
                <tr>
                  <td class="tableLabel">选配功能：</td>
                  <td colspan="3" style="border: 1px solid #dddddd;border-top: none;padding: 1%">
                    {{controlBoxFlow.optionalFunction}}
                  </td>
                  <td class="tableLabel">PG卡类型：</td>
                  <td style="border: 1px solid #dddddd;border-top: none;padding: 1%">
                    {{controlBoxFlow.pGCardType}}
                  </td>
                </tr>
                <tr>
                  <td class="tableLabel">备注：</td>
                  <td colspan="5" style="border: 1px solid #dddddd;border-top: none;padding: 1%">
                    {{controlBoxFlow.note}}
                  </td>
                </tr>
              </table>
            </div>
            <el-table
                :data="accessories"
                max-height="200"
                default-expand-all
                style="width: 100%;margin-top: 3px">
              <el-table-column align="center" label="附件名称" prop="accessoryName"/>
              <el-table-column
                  label="操作"
                  align="center"
                  class-name="vm-table_operate"
                  width="450">
                <template slot-scope="scope">
                  <el-button type="primary" @click="downloadExcel(scope.row)">下载</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="处理信息" name="second">
            <div>
              <table class="table" cellpadding="0" cellspacing="0" :data="controlBoxFlow">
                <tr>
                  <td class="tableLabel">检验员：</td>
                  <td class="tableModel">{{controlBoxFlow.creatorName}}</td>
                  <td class="tableLabel">检验员时间：</td>
                  <td class="tableModel">{{controlBoxFlow.inspectDate}}</td>
                  <td class="tableLabel">提交时间：</td>
                  <td class="tableModel">{{controlBoxFlow.inspectType}}</td>
                </tr>
                <tr>
                  <td class="tableLabel">客户名称：</td>
                  <td class="tableModel">{{controlBoxFlow.customerName}}</td>
                  <td class="tableLabel">检验类型：</td>
                  <td class="tableModel">{{controlBoxFlow.inspectType}}</td>
                  <td class="tableLabel">检验结果：</td>
                  <td class="tableModel">{{controlBoxFlow.storageInspectionResult}}</td>
                </tr>
                <tr>
                  <td class="tableLabel">基准：</td>
                  <td class="tableModel">{{controlBoxFlow.standards}}</td>
                  <td class="tableLabel">实际：</td>
                  <td class="tableModel">{{controlBoxFlow.practical}}</td>
                  <td class="tableLabel">问题大类：</td>
                  <td class="tableModel">{{controlBoxFlow.bigProblem}}</td>
                </tr>
                <tr>
                  <td class="tableLabel">问题小类：</td>
                  <td class="tableModel">{{controlBoxFlow.minorProblem}}</td>
                  <td class="tableLabel">责任部门：</td>
                  <td class="tableModel">{{controlBoxFlow.responsibleDepartment}}</td>
                  <td class="tableLabel">部门接口人：</td>
                  <td class="tableModel">{{controlBoxFlow.responsibleName}}</td>
                </tr>
                <tr>
                  <td class="tableLabel">供应商名称：</td>
                  <td class="tableModel">{{controlBoxFlow.supplierName}}</td>
                  <td class="tableLabel">处理部门：</td>
                  <td class="tableModel">{{controlBoxFlow.handleDepartment}}</td>
                  <td class="tableLabel">处理人员：</td>
                  <td class="tableModel">{{controlBoxFlow.handleName}}</td>
                </tr>
                <tr>
                  <td class="tableLabel">区域负责工程师：</td>
                  <td class="tableModel">{{controlBoxFlow.regionalManager}}</td>
                  <td class="tableLabel">是否需要处理：</td>
                  <td v-if="controlBoxFlow.needHandle === true" class="tableModel">是</td>
                  <td v-else class="tableModel">否</td>
                  <td class="tableLabel">调查结果：</td>
                  <td class="tableModel">{{controlBoxFlow.handleResult}}</td>
                </tr>
              </table>
            </div>
          </el-tab-pane>
          <el-tab-pane label="报告状态" name="third">
            <el-table
                :data="inspectionMaterials"
                default-expand-all
                style="width: 100%;margin-top: 3px">
              <el-table-column type="expand">
                <template slot-scope="props">
                  <el-table
                      :data="props.row.inspectionResults"
                      default-expand-all
                      style="width: 100%;margin-top: 3px">
                    <el-table-column align="center" label="检验项名称" prop="name"/>
                    <el-table-column align="center" label="检验标准" prop="inspectionStandard"/>
                    <el-table-column align="center" label="初检结果" prop="initialInspectionResult"/>
                    <el-table-column align="center" label="复检结果" prop="inspectionResult"/>
                    <el-table-column
                        label="操作"
                        align="center"
                        class-name="vm-table_operate"
                        width="180px">
                      <template slot-scope="scope">
                        <el-button type="primary" @click="$refs.pictureList.open(scope.row.photos,controlBoxFlow.techParamBillNo)">图片查看</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <picture-list ref="pictureList"/>
                </template>
              </el-table-column>
              <el-table-column prop="materialNO">
                <template slot-scope="scope">
                  <span style="font-weight: bold">{{scope.row.materialNO}}</span>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="工作流详情" name="fourth">
            <handle-detail :bill-id="billId" :bill-type="billType" sequ-id="-1"/>
          </el-tab-pane>
        </el-tabs>
      </el-form>
      <span slot="footer">
        <el-button type="primary" @click="dialogVisible=false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import constant from "../../../util/constant";
  import PictureList from "@/views/purchase/inspectionReport/pictureList";
  import HandleDetail from "@/views/workFlow/HandleDetail";

  export default {
    name:"Preview",
    components: {PictureList,HandleDetail},
    data() {
      return {
        constant,
        billId: "0",
        billType: "23",
        exportLoading: false,
        statu:constant.toSelect(constant.purchaseStatus,"addAll"),
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        controlBoxFlow: [],
        accessories: [],
        inspectionMaterials: [],
        activeName: "first",
        value: "",
        inspectionReport : {},
        ruleValidate: {
          postName: {required: true, message: "不能为空",trigger: "blur"},
          parentName: {required: true, message: "不能为空",trigger: "blur"},
        },
      };
    },
    methods: {
      open(row,val) {
        this.value = val;
        console.log(row);
        this.inspectionReport.billID = row.billID;
        this.billId = row.pkid + "";
        this.dialogVisible = true;
        this.getData();
      },
      getData() {
        this.contentLoading = true;
        this.$http
          .get("basic", `inspectionReports/selectControlBoxReportById/${this.inspectionReport.billID}`)
          .then(resp => {
            console.log(resp);
            this.inspectionReport = resp;
            this.controlBoxFlow = resp.controlBoxFlow;
            this.accessories = resp.accessories;
            this.inspectionMaterials = resp.inspectionMaterials;
            this.contentLoading = false;
            //this.tableData = resp.receiveDetails;
            //console.log(this.tableData);
          });
      },
      downloadExcel(row) {
        console.log(row.filePath);
        let a = document.createElement("a");
        a.href = row.filePath;
        a.download = row.accessoryName;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      },
      previewExportExcel() {
        this.exportLoading = true;
        this.$http
          .exportFile("basic",`inspectionReports/exportReportDetail/${this.inspectionReport.billID}`)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });

      },
    },
  };
</script>

<style lang="scss">
  .inspectionReport{
    .table{
      width: 100%;
      margin: 2% auto;
      border-top: 1px solid #dddddd;
      border-left: 1px solid #dddddd;
      .tableLabel{
        width: 130px;
        padding: 1%;
        background: #f4f7fa;
        border-bottom: 1px solid #dddddd;
      }
      .tableModel{
        width: 20%;
        padding: 1%;
        border-left: 1px solid #dddddd;
        border-right: 1px solid #dddddd;
        border-bottom: 1px solid #dddddd;
      }
    }
  }

</style>
